<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
  <a-modal
    :title="state.modalTitle"
    width="70%"
    :open="true"
    :confirmLoading="state.loading"
    @ok="onFormSubmit"
    @cancel="
      () => {
        emit('cancel')
      }
    "
    :bodyStyle="{ maxHeight: '75vh', overflow: 'auto' }"
  >
    <a-spin :spinning="state.loading">
      <a-form ref="ruleForm" :model="formState" v-bind="formLayout" :rules="rules">
        <a-form-item label="文章标题" name="title">
          {{ formState.title }}
        </a-form-item>
        <a-form-item label="所属栏目" name="cat_id">
          {{ formState.cat_name }}
        </a-form-item>
        <a-form-item label="文章内容" name="body" :labelCol="{ span: 5 }" :wrapperCol="{ span: 15 }">
          <div v-html="formState.body" @click="handleImageClick"></div>
        </a-form-item>
      </a-form>
    </a-spin>
    <a-image
      :width="200"
      :style="{ display: 'none' }"
      :preview="{
        visible: state.previewVisible,
        onVisibleChange: setVisible
      }"
      :src="state.previewImage"
    />
  </a-modal>
</template>

<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import ls from '@/utils/Storage'
const user = ls.get('USER_INFO')
const props = defineProps({
  detailData: {
    type: Object,
    default: () => null
  }
})
const emit = defineEmits(['cancel', 'ok'])
const ruleForm = ref()
const rules = {}
const formLayout = {
  labelCol: {
    xs: { span: 5 },
    sm: { span: 5 }
  },
  wrapperCol: {
    xs: { span: 10 },
    sm: { span: 10 }
  }
}
interface state {
  modalTitle: string
  loading: boolean
  isEdit: boolean
  roleOptions: any[]
  catList: any[]
  previewImage: string
  previewVisible: boolean
}
const state = reactive<state>({
  modalTitle: '文章详情',
  loading: false,
  isEdit: false,
  roleOptions: [],
  catList: [],
  previewImage: '',
  previewVisible: false
})
interface formState {
  cat_id: number | null
  title: string
  body: string
  cat_name: string
}
let formState = reactive<formState>({
  cat_id: null,
  title: '',
  body: '',
  cat_name: ''
})
onMounted(() => {
  if (props.detailData?.id) {
    state.isEdit = true
    queryDetail(props.detailData?.id)
  }
})
const queryDetail = (id) => {
  state.loading = true
  let requeryParam = {
    url: `/admin/v1/news/${id}/info`,
    method: 'get'
  }
  baseService(requeryParam)
    .then((res) => {
      Object.assign(formState, res.data)
      //处理一下图片，正则去掉img标签的style
      formState.body = formState.body.replace(/<img[^>]*>/gi, (imgTag) => {
        // 检查是否是SVG图片
        if (imgTag.includes('.svg') || imgTag.includes('.svg?')) {
          return imgTag // 如果是SVG，保持原样不处理
        }

        // 非SVG图片：去掉style属性并添加新样式
        const cleanTag = imgTag.replace(/\s*style\s*=\s*["'][^"']*["']/gi, '')
        return cleanTag.replace('<img', '<img style="max-width:100%;height:auto;"')
      })
    })
    .finally(() => {
      state.loading = false
    })
}
const handleImageClick = (e) => {
  // 检查点击的是否是图片
  if (e.target.tagName === 'IMG') {
    const img = e.target
    console.log('点击了图片:', img.src)
    console.log('alt属性:', img.alt)
    console.log('自定义数据:', img.dataset.src)

    // 在这里处理图片点击逻辑
    setVisible(true, img.src)
  }
}
//预览
const setVisible = (value, url): void => {
  if (value) {
    state.previewImage = url
    state.previewVisible = true
  } else {
    state.previewVisible = false
  }
}
const onFormSubmit = () => {
  emit('ok')
}
</script>

<style lang="less" scoped></style>
